// src/context/ModulesContext.tsx
import { createContext, useState, ReactNode } from "react";

/**
 * localStorage key holding the last permission payload DashboardLayout loaded.
 * Routes that render OUTSIDE DashboardLayout (today: /{lang}/403) mount with
 * an empty ModulesContext on a cold open and would otherwise have to guess
 * where the user is allowed to go.
 */
export const MODULE_PERMISSION_CACHE_KEY = "modulePermissionCache";

interface ModulesContextType {
  modules: any[];
  setModules: (modules: any[]) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const ModulesContext = createContext<ModulesContextType>({
  modules: [],
  setModules: () => {},
  isLoading: true,
  setIsLoading: () => {},
});

export const ModulesProvider = ({ children }: { children: ReactNode }) => {
  const [modules, setModules] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  return (
    <ModulesContext.Provider
      value={{ modules, setModules, isLoading, setIsLoading }}
    >
      {children}
    </ModulesContext.Provider>
  );
};

export default ModulesContext;
